import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Box,
  Typography,
  Link,
} from "@mui/material";
import * as React from "react";
import { AuthenticationContext } from "../Context";
import { useHistory } from "react-router-dom";
import { getHeaders } from "../utils/HeaderHelper";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CreateIcon from "@mui/icons-material/Create";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { formatToUsDate } from "../utils/DateHelper";
import { useFlash } from "../FlashContext";

const ProgramManagement: React.FC = (props: any) => {
  const auth = React.useContext(AuthenticationContext);
  const { showToast } = useFlash(); 
  const history = useHistory();

  const [programs, setPrograms] = React.useState([]);

  const getPrograms = () => {
    fetch(`/programs/published_programs`, {
      method: "GET",
      headers: getHeaders(auth.csrfToken),
    })
      .then((r) => r.json())
      .then((result) => {
        if (result.success === false) {
          showToast({
            title: "Error Fetching Programs",
            text: result.message || "Error fetching programs",
            type: "error",
          });
        } else {
          setPrograms(result?.data?.programs);
        }
      })
      .catch((_e) => {
        showToast({
          title: "Network Error",
          text: "Network error fetching programs",
          type: "error",
        });
      });
  };

  React.useEffect(() => {
    getPrograms();
  }, []);

  const handleViewProgram = (program) => {
    history.push(`/program-management/${program.id}/view`);
  };

  const handleTransferProgram = (program) => {
    history.push(`/program-management/${program.id}/transfer`);
  };

  const handleUnassignProgram = (program) => {
    history.push(`/program-management/${program.id}/unassign`);
  };

  return (
    <div className="main-content-outer">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="main-content"
        sx={{ paddingLeft: "138px" }}
      >
        <Grid
          item
          xs={12}
          className="patient-edit-container patient-edit-form"
          sx={{ paddingBottom: "0px" }}
        >
          <Grid container>
            <Grid container direction="row" className="admin-header">
              <Grid item xs={12} className="box-header">
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  paddingX={3}
                  paddingY={1}
                  alignItems={"center"}
                  display={"flex"}
                >
                  <Grid item>
                    <Stack direction="row" columnGap="12px" alignItems="center">
                      <Link
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                        }}
                        href={`/actions-and-programs`}
                      >
                        <ArrowBackIosNewIcon
                          style={{
                            borderRadius: "3px",
                            padding: "8px",
                            color: "black",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            fontSize: "14px",
                          }}
                        />
                      </Link>
                      <p className="panel-header">Program Management</p>
                    </Stack>
                  </Grid>
                </Stack>
              </Grid>
            </Grid>

            <Box className="program-management-info-container">
              <Grid container sx={{ backgroundColor: "white" }}>
                <Grid
                  item
                  xs={12}
                  className="form-container"
                  sx={{ paddingBottom: "0px !important" }}
                >
                  {programs && programs?.length === 0 ? (
                    <Typography
                      style={{
                        color: "#1E1E1E",
                        textAlign: "center",
                        fontSize: "13px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "18px",
                        padding: "8px",
                      }}
                    >
                      The list is currently empty
                    </Typography>
                  ) : (
                    <TableContainer style={{ maxHeight: "calc(80vh - 200px)" }}>
                      <Table stickyHeader aria-label="a dense table">
                        <TableHead
                          sx={{
                            boxShadow: "0px 4px 4px 0px #00000040",
                            backgroundColor: "#fff",
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                          }}
                        >
                          <TableRow
                            sx={{
                              "& td, & th": {
                                borderBottom: "none",
                              },
                            }}
                          >
                            <TableCell align="left" sx={{ width: "350px" }}>
                              Program Name
                            </TableCell>
                            <TableCell align="left">Published Date</TableCell>
                            <TableCell align="left">Patient Count</TableCell>
                            <TableCell align="center" sx={{ width: "34px" }}>
                              View
                            </TableCell>
                            <TableCell align="center" sx={{ width: "70px" }}>
                              Transfer
                            </TableCell>
                            <TableCell align="center" sx={{ width: "60px" }}>
                              Unassign
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {programs?.map((program) => (
                            <TableRow
                              sx={{ "& td, & th": { borderBottom: "none" } }}
                              key={program.id}
                            >
                              <TableCell align="left">
                                {program.title}
                              </TableCell>
                              <TableCell align="left">
                                {program.published_at
                                  ? formatToUsDate(program.published_at)
                                  : "N/A"}
                              </TableCell>
                              <TableCell align="left">
                                {program.patient_count || 0}
                              </TableCell>
                              <TableCell align="center">
                                <VisibilityIcon
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleViewProgram(program)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <CreateIcon
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleTransferProgram(program)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <DeleteIcon
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleUnassignProgram(program)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProgramManagement;
